import type { Field } from '../types';

export type FieldStatus = 'pending' | 'accepted' | 'rejected';
export type AssignableFieldKey = 'interview' | 'examination' | 'recommendations';
export type FieldKey = AssignableFieldKey | 'unassigned';
export type FieldCardVariant = 'assignable' | 'unassigned';

export const ASSIGNABLE_FIELDS: AssignableFieldKey[] = ['interview', 'examination', 'recommendations'];

export const FIELD_TO_VISIT_FIELD: Record<AssignableFieldKey, Field> = {
   interview: 'INTERVIEW',
   examination: 'EXAMINATION',
   recommendations: 'RECOMMENDATIONS',
};
